import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
const letsTryItems = [
    {
        title: 'レッスンをする',
        description: 'レッスンは2分から！',
        icon: 'assets/images/icons/task_lesson.svg',
    },
    {
        title: '食事を記録する',
        description: '1食でもOK！',
        icon: 'assets/images/icons/task_meal.svg',
    },
    {
        title: 'ワークアウト目標を達成する',
        description: '目標消費カロリーをクリア！',
        icon: 'assets/images/icons/task_workout.svg',
    },
    {
        title: 'ウォーキング目標を達成する',
        description: '目標歩数をクリア！',
        icon: 'assets/images/icons/task_steps.svg',
    },
    {
        title: '体重を記録する',
        description: '自分の身体の状態を知ろう！',
        icon: 'assets/images/icons/task_weight.svg',
    },
];
export const GoalMatchingAssessmentResultLetsTry = ({ classObject, message, shouldAnimateListItems, }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.message) }, message),
        React.createElement("ul", { className: css(styles.list) }, letsTryItems.map(({ title, description, icon }, index) => (React.createElement("li", { key: title, className: css(styles.listItem, shouldAnimateListItems && styles.listItemAnimated), style: shouldAnimateListItems && { opacity: 0, animationDelay: `${index * 500}ms` } },
            React.createElement("img", { src: icon, className: css(styles.iconWrapper) }),
            React.createElement("div", { className: css(styles.textWrapper) },
                React.createElement("div", { className: css(styles.itemTitle) }, title),
                React.createElement("div", { className: css(styles.itemDescription) }, description))))))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
    },
    message: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.28,
        width: '100%',
        textAlign: 'center',
        whiteSpace: 'pre-wrap',
    },
    character: {
        width: 80,
        height: 80,
        flexShrink: 0,
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    listItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 10px 8px 20px',
        borderRadius: 40,
        background: Colors.White,
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.06)',
    },
    listItemAnimated: {
        animationName: {
            from: {
                opacity: 0,
                transform: 'translateY(-30px)',
            },
            to: {
                opacity: 1,
                transform: 'translateY(0)',
            },
        },
        animationDuration: '600ms',
        animationTimingFunction: 'ease',
        animationFillMode: 'forwards',
    },
    iconWrapper: {
        width: 54,
        height: 54,
    },
    textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    itemTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '100%',
    },
    itemDescription: {
        fontSize: 12,
        lineHeight: '100%',
    },
});
